import Chip from '@mui/material/Chip'

const AutoBadge = ({ reclip, size = 'small', sx }) => {
  if (reclip?.capture_mode !== 'auto') return null
  const label = reclip.capture_trigger || 'AUTO'

  return (
    <Chip
      label={label}
      size={size}
      sx={{
        backgroundColor: '#DAFC79',
        color: '#121212',
        fontWeight: 700,
        '& .MuiChip-label': { color: '#121212' },
        ...sx,
      }}
    />
  )
}

export default AutoBadge
